module.exports = __webpack_public_path__ + "assets/copy.0c1c21bc.svg";